// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as FareEstimateV2Helper$PorterinFeature from "../../../domain/helpers/FareEstimateV2Helper.mjs";

function initialFormState(address) {
  return {
          house_address: Belt_Option.getWithDefault(address.house, ""),
          name: Belt_Option.getWithDefault(address.name, ""),
          mobile: Belt_Option.getWithDefault(address.number, "")
        };
}

function onFormSubmit(output, waypoint, close_modal, param, param$1) {
  var receiver = param$1[0];
  var sender = param[0];
  if (waypoint) {
    Curry._1(param$1[1], {
          pickup_address: receiver.pickup_address,
          drop_address: receiver.drop_address,
          name: output.name,
          number: output.mobile,
          house: output.house_address
        });
  } else {
    Curry._1(param[1], {
          pickup_address: sender.pickup_address,
          drop_address: sender.drop_address,
          name: output.name,
          number: output.mobile,
          house: output.house_address
        });
  }
  FareEstimateV2Helper$PorterinFeature.setBookingDetailsInStorage(output, waypoint);
  Curry._1(close_modal, undefined);
}

export {
  initialFormState ,
  onFormSubmit ,
}
/* FareEstimateV2Helper-PorterinFeature Not a pure module */
